import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import 'slick-carousel';
import 'parsleyjs';
import './plugins/garlic.min'; // persist form data (recipe notes) locally
import './components/handle-favorites';
import 'electro-privacy';

/* global $BV */
/* global YT */

/// ////////////////////////////////////////////////////////////////////////////
// Routes
/// ////////////////////////////////////////////////////////////////////////////

// On-Demand (dynamic) modules
// https://webpack.js.org/guides/code-splitting/#dynamic-imports
const { pathname } = window.location;
const { classList } = document.body;
const bodyID = document.body.id;

(async () => {
    if (classList.contains('home')) {
        await import(
            /* webpackChunkName: "home" */
            './pages/home'
        );
    }
    if (pathname.match(/\/saucy-tips/)) {
        await import(
            /* webpackChunkName: "archive-video-tips" */
            './pages/archive-video-tips'
        );
    }
    if (pathname.match(/\/recipes/)) {
        await import(
            /* webpackChunkName: "archive-recipe" */
            './pages/archive-recipe'
        );
    }
    if (pathname.match(/\/recipes-for-delivery/)) {
        await import(
            /* webpackChunkName: "archive-recipe" */
            './pages/archive-recipe'
        );
    }
    if (pathname.match(/\/faqs/)) {
        await import(
            /* webpackChunkName: "faq" */
            './pages/faq'
        );
    }
    if (pathname.match(/\/poll/)) {
        await import(
            /* webpackChunkName: "poll-cookie" */
            './pages/poll-cookie'
        );
    }
    if (pathname.match(/\/ok-soy-vay/)) {
        await import(
            /* webpackChunkName: "ok-videos" */
            './pages/ok-videos'
        );
    }
    if (pathname.indexOf('/products/') !== -1) {
        await import(
            /* webpackChunkName: "single-flavor" */
            './pages/single-flavor'
        );
    }
    if (pathname.indexOf('/recipes/') !== -1) {
        await import(
            /* webpackChunkName: "single-recipe" */
            './pages/single-recipe'
        );
    }
    if (pathname.indexOf('/products/') !== -1) {
        await import(
            /* webpackChunkName: "product-landing" */
            './pages/product-landing'
        );
    }
})();

/// ////////////////////////////////////////////////////////////////////////////
// SiteCommon
/// ////////////////////////////////////////////////////////////////////////////

(function ($) {
    const $window = $(window);
    const $root = $('html, body');

    SoyVay.svCommon = (function () {
        function privateInitListeners() {
            // Define instance variables
            const navToggleButton = document.querySelector('.nav-toggle');
            const navMenuContainer = document.querySelector('.nav-container__global');
            const searchBar = document.querySelector('.nav-container__global');
            const loginToggleButton = document.querySelector('.login-toggle');

            // Smooth scrolling
            const scrollTo = function (pos) {
                $root.animate(
                    {
                        scrollTop: pos,
                    },
                    500
                );
            };

            $('.back-to-top').click((e) => {
                scrollTo(0);
                return false;
            });

            $('a.scroll-link').click(function () {
                scrollTo($(jQuery.attr(this, 'href')).offset().top);
                return false;
            });

            // Open external links in new window
            // var a = new RegExp('/' + window.location.host + '/');
            // $('a').each(function() {
            //    if(!a.test(this.href)) {
            //        $(this).click(function(event) {
            //            event.preventDefault();
            //            event.stopPropagation();
            //            window.open(this.href, '_blank');
            //        });
            //    }
            // });

            /** ****************************************************************
             ** Navigation & Account toggling, masking, and activating functions
             ***************************************************************** */
            function toggleNavMenu() {
                navMenuContainer.classList.toggle('active');
                navToggleButton.classList.toggle('active');

                if ($(navToggleButton).is('.active')) {
                    // make sure the search icon is not visible
                    $('.search-toggle').hide();
                } else {
                    // make sure the search icon is visible
                    $('.search-toggle').show();
                }
            }

            function toggleLoginState() {
                $(loginToggleButton).toggleClass('active');
            }

            // keep track of whether the user used hover to use the submenu
            const mainMenuItems = $('#nav-global-menu .menu-item');
            let submenuHovered = false;
            const isDesktopNavMenu = function () {
                return $(window).width() > 1024;
            };

            // define generic expand/collapse functions
            function subMenuExpand(el) {
                const $thisSubmenu = $(el).find('.sub-menu');
                $thisSubmenu.addClass('expanded');
                $thisSubmenu.attr('aria-hidden', 'false');
                $(el).find('.expand-toggle').addClass('active');
            }

            function subMenuCollapse(el) {
                const $thisSubmenu = $(el).find('.sub-menu');
                $thisSubmenu.removeClass('expanded');
                $thisSubmenu.attr('aria-hidden', 'true');
                $(el).find('.expand-toggle').removeClass('active');
            }

            // expand sub menu on hover on large screens
            mainMenuItems.has('.sub-menu').mouseenter(function (e) {
                // only on desktop. 1025px = scss $mq-xl-min
                if (isDesktopNavMenu()) {
                    subMenuExpand($(this));
                    submenuHovered = true;
                }
            });

            // collapse sub menu when the mouse leaves if the menu was originally expanded by hover
            // (allows compatibilty with existing click toggle functions above)
            mainMenuItems.has('.sub-menu').mouseleave(function (e) {
                if (isDesktopNavMenu() && submenuHovered) {
                    subMenuCollapse($(this));
                    submenuHovered = false;
                }
            });

            // expand submenu on focus
            $('#nav-global-menu .menu-item').on('focusin', function (e) {
                // ensure any other adjacent elements' sub-menus are collapsed
                subMenuCollapse($(this).siblings());

                // if there is a sub menu to work with
                if ($(this).has('.sub-menu')) {
                    // expand it
                    subMenuExpand($(this));
                }
            });

            // collapse submenu on focusout
            mainMenuItems.has('.sub-menu').on('focusout', function (e) {
                // cache this
                const element = $(this);

                // use delay to give browser time to understand what it's focused on
                setTimeout(() => {
                    // if there are any elements inside the element we just left
                    if (element.find(':focus').length === 0) {
                        // collapse its submenu
                        subMenuCollapse(element);
                    }
                }, 100);
            });

            // custom arrow key bindings for rapid navigation
            $('#nav-global-menu a').on('keydown', (event) => {
                if (event.which === 37 || event.which === 38 || event.which === 39 || event.which === 40) {
                    event.preventDefault();
                }

                const parentItem = $(event.target).parents('.menu-item');

                if (isDesktopNavMenu()) {
                    // bind right and left arrows to move between top level items
                    switch (event.which) {
                        case 37:
                            // console.log("left");
                            parentItem.prev().find('a').first().focus();
                            break;
                        case 39:
                            // console.log("right");
                            parentItem.next().find('a').first().focus();
                            break;
                        default:
                        // no action
                    }
                } else {
                    // use up and down because nav is stacked vertically on small screens
                    switch (event.which) {
                        case 38:
                            // console.log("up");
                            parentItem.prev().find('a').first().focus();
                            break;
                        case 40:
                            // console.log("down");
                            parentItem.next().find('a').first().focus();
                            break;
                        default:
                        // no action
                    }
                }
            });

            $('.expand-toggle').on('mousedown', (event) => {
                // prevent the focus event from calling other methods used for keyboard nav
                event.preventDefault();
            });

            $('.expand-toggle').on('click', function (event) {
                event.stopPropagation();
                event.preventDefault();

                const $thisSubmenu = $(this).parents('.menu-item').find('.sub-menu');

                if ($thisSubmenu.hasClass('expanded')) {
                    $(this).removeClass('active');
                    $thisSubmenu.removeClass('expanded');
                    $thisSubmenu.attr('aria-hidden', 'true');
                } else {
                    $thisSubmenu.find('.submenu a:first-child').focus();
                    $(this).addClass('active');
                    $thisSubmenu.addClass('expanded');
                    $thisSubmenu.attr('aria-hidden', 'false');
                }
            });

            // bind to events
            navToggleButton.addEventListener('click', toggleNavMenu);

            // if user has clicked on anything BUT the nav-container, close the menu
            // https://css-tricks.com/dangers-stopping-event-propagation/
            // ^Explains why we use the $().closest().length logic
            // Any way to do this without checking every single document click?
            $(document).on('click', (e) => {
                // If the navigation menu is open
                if (navMenuContainer.classList.contains('active')) {
                    // If we have clicked anywhere outside of the navigation menu
                    if (
                        !$(e.target).closest('.nav-container__global').length &&
                        !$(e.target).closest('.nav-toggle').length
                    ) {
                        toggleNavMenu();
                    }
                }
            });

            // Remove the active state on the login button if clicked outside
            // Uses similar logic to the click event above
            $(document).on('click', (e) => {
                if ($(loginToggleButton).hasClass('active')) {
                    if (!$(e.target).closest('.modal-content').length && !$(e.target).closest('.login-toggle').length) {
                        toggleLoginState();
                    }
                }
            });

            // toggle active state of login modal link by hooking into Bootstrap events
            $('#loginModal').on('shown.bs.modal', (e) => {
                toggleLoginState();
            });

            $('#loginModal').on('hidden.bs.modal', (e) => {
                toggleLoginState();
            });

            // toggle expansion of user sub menu when user greet has :hover
            $('.nav-user.logged-in').mouseenter(function (e) {
                $(this).find('.sub-menu').addClass('expanded');
                $(this).find('.sub-menu').attr('aria-hidden', 'false');
            });

            $('.nav-user.logged-in').mouseleave(function (e) {
                $(this).find('.sub-menu').removeClass('expanded');
                $(this).find('.sub-menu').attr('aria-hidden', 'true');
            });

            /** ****************************************************************
             ** SEARCH FX
             ***************************************************************** */

            // use javascript to change the icon to an X because it's spec'd as an X for mobile only
            $('.search-toggle').on('click', function () {
                if ($(this).is('.active')) {
                    $(this).removeClass('active');
                    $('.gcse-container').css('visibility', 'hidden');
                    $('.search-close').removeClass('active');
                    $('.gcse-searchbutton').removeClass('active');
                    // make sure the hamburgesa is visible
                    $('.nav-toggle').show();
                } else {
                    $(this).addClass('active');
                    $('.gcse-container').css('visibility', 'visible');
                    $('.search-close').addClass('active');
                    // make sure the hamburgesa is not visible
                    $('.nav-toggle').hide();
                }
            });

            $('.gcse-container .search-close').on('click', function (e) {
                e.preventDefault();
                $(this).removeClass('active');
                $('.gcse-container').css('visibility', 'hidden');
                $('.search-toggle').removeClass('active');
            });

            // now we know how they got here
            $('.gcse-searchbox')
                .on('click', function () {
                    $(this).addClass('clicked');
                })
                .on('blur', function () {
                    $(this).removeClass('clicked');
                });

            // toggle class on search form container when its children-puts are :focus
            $('.gcse-container input')
                .on('focus', function () {
                    $(this).parents('.gcse-container').addClass('focused');
                })
                .on('blur', function () {
                    $(this).parents('.gcse-container').removeClass('focused');
                });

            // prevent accidental and intentional form submits when there is no query
            $('#gcse-searchform').on('submit', function (event) {
                if ($('#gcse-searchbox').val().length < 1) {
                    // super duper IE-friendly prevent default
                    event.preventDefault();
                    // send 'em back to the search field'
                    $(this).find('[type=search]').focus();
                }
            });

            /** ****************************************************************
             ** Banners/Coupon Interactions
             ***************************************************************** */

            // close the banner (often a coupon) that is at the top of the page
            $('.js-close-banner').on('click', (e) => {
                e.preventDefault();
                closeBanner();
                // set cookie so that we remember the banner is closed
                if (
                    document.cookie.replace(/(?:(?:^|.*;\s*)hideCouponBanner\s*=\s*([^;]*).*$)|^.*$/, '$1') !== 'true'
                ) {
                    document.cookie = 'hideCouponBanner=true; expires=60*60*24*52;';
                }
            });

            // Check cookie to see if CTA banner should be closed
            if (document.cookie.replace(/(?:(?:^|.*;\s*)hideCouponBanner\s*=\s*([^;]*).*$)|^.*$/, '$1') === 'true') {
                $('.banner__coupon').hide();
            }

            // .each() is used to create a closure to store a cache of the query.
            $('.js-accordion-toggle').each(function () {
                const $content = $(this).closest('div').find('.accordion-content');
                $(this).click((e) => {
                    e.preventDefault();
                    $content.not(':animated').slideToggle();
                });
            });

            function closeBanner() {
                $('.banner__coupon').fadeOut('slow', () => {});
            }

            /** ****************************************************************
             ** Videos/YouTube Players
             ***************************************************************** */

            /* ----------  auto modalize special types of youtubes  ----------*/
            // find any elements with .yt-video-modal hijack their behavior to
            // make them play in a modal generated by this script

            if ($('.yt-video-modal').length > 0) {
                // gather an array of any youtube iframe wannabes on the page
                const players = $('.yt-video-modal').toArray();
                const iFrameURL = $('.modal-video--template').find('iframe').attr('src');

                // loop through all potential youtubes
                for (let i = players.length - 1; i >= 0; i -= 1) {
                    // remember things
                    const player = players[i];
                    const videoID = $(player).data().youtube;

                    // handle an "oops" scenario
                    if (!videoID) {
                        // there's a .yt-video element but it doesn't have a video id
                        if (SoyVay.DEBUG) {
                            console.info($(player), 'does not have a `data-video` attribute with YouTube Video ID');
                        }
                    } else {
                        // add bs modal references to element
                        $(player).attr('data-toggle', 'modal').attr('data-target', `#video-${videoID}`);

                        // clone and permute video template
                        const video = $('.modal-video--template')
                            .clone(true)
                            .removeClass('modal-video--template')
                            .attr('id', `video-${videoID}`);
                        video.insertAfter('.modal-video--template');

                        $(`#video-${videoID}`)
                            .find('iframe')
                            .attr('id', `video-iframe-${videoID}`)
                            .attr('src', iFrameURL.replace('%ID%', videoID));
                    }
                }
            }

            // eliminate the parent of the clones
            $('.modal-video--template').remove();

            /* ----------  Fix for Webkit browsers ignoring video autoplay attribute  ----------*/

            // select all video elements, bind to event fired when buffered
            $('video[autoplay]').on('canplaythrough', function () {
                this.play();
            });

            /* ----------  Stop video playback on modal close  ----------*/

            const $videoModals = $('.modal-video');
            $videoModals.on('hidden.bs.modal', function () {
                const videoSrc = $(this).find('iframe').attr('src');
                $(this).find('iframe').attr('data-src', videoSrc);
                $(this).find('iframe').removeAttr('src');
            });

            /* ----------  Reload closed videos  ----------*/

            $videoModals.on('show.bs.modal', function () {
                const videoSrc = $(this).find('iframe').attr('data-src');
                if (videoSrc) {
                    $(this).find('iframe').attr('src', videoSrc);
                }
            });

            /** ****************************************************************
             ** FILTER NAVIGATION FOR CATEGORICAL GROUPS OF POST GRIDS
             ***************************************************************** */

            // general hide function
            function sectionHide() {
                $('.category-section').hide();
            }

            // general remove class function
            function removeActive() {
                $('.js-post-landing-filter a').removeClass('active');
            }

            // find url strings for filtering
            const queries = {};
            $.each(document.location.search.substr(1).split('&'), (c, q) => {
                const i = q.split('=');
                if (i.length > 1) {
                    queries[i[0].toString()] = i[1].toString();
                }
            });

            // set text of mobile category filter indicator to current category
            let $currentCategory;
            function indicateCategory() {
                $currentCategory = $('.js-post-landing-filter .active');
                if ($currentCategory.length > 0) {
                    $('.post-filter-nav__current a span').text($currentCategory.text());
                }
            }
            indicateCategory();

            // check for the ?category param in the URI
            if (typeof queries.category !== 'undefined') {
                sectionHide();
                removeActive();
                // special behavor for marinades and dressings
                if (queries.category.indexOf('marinades-and-dressings') > -1) {
                    $('#section-marinades').fadeIn(250, () => {});
                    $('#section-dressings').fadeIn(250, () => {});
                    $('.nav-icon-marinades').addClass('active');
                    $('.nav-icon-dressings').addClass('active');
                    // special case for rice and noodles
                } else if (queries.category.indexOf('rice-and-noodles') > -1) {
                    $('#section-rice').fadeIn(250, () => {});
                    $('#section-noodles').fadeIn(250, () => {});
                    $('.nav-icon-rice').addClass('active');
                    $('.nav-icon-noodles').addClass('active');
                    // otherwise just show the section called for in ?category
                } else {
                    $(`#section-${queries.category}`).fadeIn(250, () => {});
                    $(`.nav-icon-${queries.category}`).addClass('active');
                }
            }

            // post filter dropdown on small screens
            $('.post-filter-nav__current').on('click', 'a', function (event) {
                event.preventDefault();
                const $filter = $(this).parents('.js-post-filter-nav');
                if ($filter.hasClass('expanded')) {
                    $(this).parents('.js-post-filter-nav').removeClass('expanded');
                    $('.post-filter-nav__container').fadeOut(250, () => {});
                    $('.modal-overlay').fadeOut(250, () => {});
                } else {
                    $(this).parents('.js-post-filter-nav').addClass('expanded');
                    $('.post-filter-nav__container').fadeIn(250, () => {});
                    $('.modal-overlay').fadeIn(250, () => {});
                }
            });

            // filtering for posts
            $('.post-filter-nav__container').on('click', 'a', function () {
                const $category = $(this).attr('data-category');
                const $section = $(`#section-${$category}`);
                const $filter = $(this).parents('.js-post-filter-nav');
                const $filterIsExpanded = $filter.hasClass('expanded');

                removeActive();

                if ($category === 'all') {
                    $('.category-section').fadeIn(250, () => {});
                    $(this).addClass('active');
                    window.history.pushState(window.location.pathname, null, window.location.pathname);
                } else {
                    sectionHide();
                    $(`#section-${$category}`).fadeIn(250, () => {});
                    $(this).addClass('active');

                    // write browser history and write url like '/?category=snacks'
                    const catURL = `?category=${$category}`;
                    window.history.pushState(catURL, null, catURL);
                }

                indicateCategory();

                if ($filterIsExpanded) {
                    $filter.removeClass('expanded');
                    $('.post-filter-nav__container').fadeOut(250, () => {});
                    $('.modal-overlay').fadeOut(250, () => {});
                }
            });

            /*= =======================================================
             =            BazaarVoice Custom Interactions            =
             ======================================================== */
            $('.js-write-review').on('click', (e) => {
                e.preventDefault();
                $BV.ui('rr', 'submit_review', { productId: SoyVay.bvID });
            });

            /*= ========================================
            =       Revelator Read More button       =
            ========================================= */
            // supports one set of undisclosed elements per web page
            // and infinite number of reveal buttons

            function revelator() {
                const $revelator = $('.js-revelator');
                const $revelatorElements = $('.js-revelator-toggle');
                const $revelatorContainer = $('.revelator__container');

                // show the element containing the button
                $($revelatorContainer).addClass('active');

                // ensure there are relevelements to operate on
                if ($revelatorElements.length > 0) {
                    // loop though all toggle-able elements
                    for (let i = $revelatorElements.length - 1; i >= 0; i -= 1) {
                        // we have special plans for the first one
                        if (i === 0) {
                            $($revelatorElements[0]).addClass('revelator-teaser');
                        } else {
                            // but the rest need to go away
                            $($revelatorElements[i]).addClass('revelator-hidden');
                        }
                    }

                    // set up click handler
                    $($revelator).on('click', function (event) {
                        event.preventDefault();

                        for (let i = $revelatorElements.length - 1; i >= 0; i -= 1) {
                            // remove classes from new-to-be formerly-revelated elements
                            $($revelatorElements[i]).removeClass('revelator-hidden revelator-teaser');
                        }

                        // hide the revelator container, and theoretically the button too
                        $(this).parents('.revelator__container').hide();
                    });
                }
            }

            // only revelate stuff for less endowed viewports
            const windowWidth = $(window).width();
            if (windowWidth < 769) {
                revelator();
            }
        }

        return {
            initListeners() {
                privateInitListeners();
            },
        };
    })();

    // document ready
    $(document).ready(() => {
        SoyVay.svCommon.initListeners();

        // Returns true if the current time is outside of business hours (Monday to Friday, 9:00 AM - 5:30 PM EST)
        const isOutsideBusinessHours = () => {
            // Get the current date and time in UTC
            const now = new Date();

            // Convert to US Eastern Time by offsetting from UTC
            const options = {
                timeZone: 'America/New_York',
                hour12: false,
                weekday: 'short',
                hour: '2-digit',
                minute: '2-digit',
            };
            const estTimeString = now.toLocaleTimeString('en-US', options);
            const [weekday, time] = estTimeString.split(' ');

            const [hour, minute] = time.split(':').map(Number);

            // Check if it's outside Monday to Friday
            if (!['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(weekday)) {
                return true;
            }

            // Check if the time is outside 9:00 AM - 5:30 PM
            const beforeBusinessHours = hour < 9;
            const afterBusinessHours = hour > 17 || (hour === 17 && minute > 30);

            if (beforeBusinessHours || afterBusinessHours) {
                return true;
            }

            // It's within business hours (Monday-Friday, 9 AM - 5:30 PM EST)
            return false;
        };

        // Quiq chat init
        const quiqChatButton = document.getElementById('quiq-chat-button');

        if (quiqChatButton && isOutsideBusinessHours()) {
            quiqChatButton.classList.add('disabled');
            quiqChatButton.addEventListener('click', (e) => {
                e.preventDefault();
            });
        }

        if (quiqChatButton) {
            const interval = setInterval(() => {
                if (typeof OptanonActiveGroups === 'undefined') return;
                clearInterval(interval);
                // eslint-disable-next-line no-undef
                if (OptanonActiveGroups.indexOf('C0003') > -1) {
                    const scriptElement = document.createElement('script');
                    scriptElement.type = 'text/javascript';
                    scriptElement.src = 'https://clorox.quiq-api.com/app/chat-ui/index.js';
                    document.head.appendChild(scriptElement);
                    const interval2 = setInterval(() => {
                        if (typeof Quiq === 'undefined') return;
                        clearInterval(interval2);

                        // eslint-disable-next-line no-undef, no-unused-vars
                        const chat = Quiq({ pageConfigurationId: 'soy-vay' });
                    }, 100);
                } else {
                    const chatConsentMessage = document.createElement('div');
                    chatConsentMessage.classList.add('consent-message');
                    chatConsentMessage.innerHTML =
                        'Please enable <a href="#" class="ot-sdk-show-settings">cookies</a> to chat.';
                    quiqChatButton.parentElement.appendChild(chatConsentMessage);
                    quiqChatButton.remove();
                }
            }, 100);
        }

        // OneTrust
        document.getElementById("do-not-share").addEventListener("click", () => {
            // eslint-disable-next-line no-undef
            if (typeof OneTrust !== "undefined") {
                // eslint-disable-next-line no-undef
                OneTrust.ToggleInfoDisplay();
            }
        });
    });
})(jQuery);

// common functions that may be called from other scripts
SoyVay.createCookie = function createCookie(name, value, days, rootDomain) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toGMTString()}`;
    }
    const secure = window.location.protocol === 'https:' ? '; secure' : '';
    // check if we should set for the "root domain" ie .soyvay.com
    let domain = '';
    if (rootDomain) {
        let { hostname } = window.location;
        const splitArr = hostname.split('.');
        if (splitArr.length > 2) {
            hostname = `${splitArr[splitArr.length - 2]}.${splitArr[splitArr.length - 1]}`;
        }
        domain = `domain=${hostname};`;
    }

    document.cookie = `${name}=${value}${expires};${domain}path=/${secure}`;
};

SoyVay.readCookie = function (name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null;
};

SoyVay.storageSupported = function () {
    const storage = window.localStorage;
    const key = 'test';
    try {
        storage.setItem(key, '1');
        storage.removeItem(key);
        return true;
    } catch (error) {
        return false;
    }
};

/* ----------  YouTube API: Video Image Cover Toggle  ----------*/

window.player = {};
$('.video-feature .video--wrapper').each(function () {
    const id = $(this).find('iframe').attr('id');
    window.player[id] = {};
});
window.onYouTubePlayerAPIReady = function () {
    Object.keys(window.player).forEach((key) => {
        window.player[key] = new YT.Player(key, {
            events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange,
            },
        });
    });
};

function onPlayerReady(event) {
    if (SoyVay.DEBUG) {
        console.info('onPlayerReady()');
    }

    const playerFrame = event.target.getIframe();
    const isAFrame = playerFrame instanceof HTMLElement;

    if (isAFrame) {
        const { id } = playerFrame;
        const playButton = document.querySelector(`.js-image-over-video[data-video-id="${id}"]`);
        $(`.video-feature[data-video-id="${id}"]`).css('opacity', '0').show();
        const playVideo = function (eventInner) {
            eventInner.preventDefault();
            window.player[id].playVideo();
            $(`.video-feature[data-video-id="${id}"]`).animate({ opacity: '1' });
            $(`.js-image-over-video[data-video-id="${id}"]`).fadeOut(600);
        };

        playButton.addEventListener('click', playVideo);
        playButton.addEventListener('keydown', (eventInner) => {
            if (eventInner.keyCode === 13 || eventInner.keyCode === 32) {
                playVideo(eventInner);
            }
        });
    }
}
function onPlayerStateChange(event) {
    const playerFrame = event.target.getIframe();
    const isAFrame = playerFrame instanceof HTMLElement;

    if (event.data === 0 && isAFrame) {
        const { id } = playerFrame;
        $(`.js-image-over-video[data-video-id="${id}"]`).fadeIn(0, () => {
            $(`.video-feature[data-video-id="${id}"]`).animate({ opacity: '0' });
        });
    }
}

window.social = {
    newWindow(url) {
        const left = (window.screen.width - 570) / 2;
        const top = (window.screen.height - 570) / 2;
        const params = `menubar=no,toolbar=no,status=no,width=570,height=570,top=${top},left=${left}`;
        window.open(url, 'NewWindow', params);
    },
};

// Youtube API
const tag = document.createElement('script');
tag.src = '//www.youtube.com/player_api';
tag.className = 'optanon-category-C0004';
tag.type = 'text/plain';
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
